(function ($) {
  $('.show-references').click(function () {
    $(this).parent().addClass('is-visible');
  });

  $('.navbar-burger').click(function (e) {
    e.preventDefault();

    $('.navbar-burger, .navbar-menu, header.top').toggleClass('is-active');

    return false;
  });

  $('a[href="#"]').attr('title', 'Under Construction').css({ 'cursor': 'not-allowed'});

  $('.authors > .author > .name').click(function (e) {
    e.preventDefault();
    var $author = $(this).parent();
    var $affiliations = $author.children('.affiliations');

    $('.authors > .author').not($author).removeClass('is-visible');
    $author.toggleClass('is-visible');

    var x1 = $affiliations.offset().left;
    var x2 = $affiliations.offset().left + $affiliations.outerWidth();

    if (!$affiliations.data('calculated')) {
      if (x1 < 10) $affiliations.css('margin-left', String(10 - x1) + 'px');
      if (x2 > window.outerWidth - 10) $affiliations.css('margin-left', String(window.outerWidth - 10 - x2) + 'px');
    }

    $affiliations.data('calculated', true);

    return false;
  }).mousedown(function (e) { e.preventDefault(); return false; });

  $('.authors > .author > .affiliations > .close').click(function (e) {
    e.preventDefault;

    $(this).parent().parent().removeClass('is-visible');

    return false;
  });

  $('a.share, a.toc').click(function (e) {
    e.preventDefault();

    var c = $(this).attr('class');
    var $widget = $('.widget.' + c);

    if ($widget.hasClass('visible')) {
      $widget.removeClass('visible');
    } else {
      $('.widget.visible').removeClass('visible');
      $widget.addClass('visible');
    }

    return false;
  });

  $('a.loi').click(function (e) {
    e.preventDefault();

    $('div[id^="attachment_"]').first().find('img').click();

    setTimeout(function () { $('.f-sidebar-button').click(); }, 10);

    return false;
  })

  $('.newsletter-promo')
    .on('click', '.show-form', undefined, function () {
      $('.newsletter-promo .intro, .newsletter-promo .show-form').addClass('is-hidden');
      $('.newsletter-promo .form').removeClass('is-hidden');
    })
    .on('click', '.submit', undefined, function () {
      $('.newsletter-promo .button.submit').attr('disabled', 'disabled');
      $('.newsletter-promo .control:has(input[type=email])').addClass('is-loading');

      var email = $('.newsletter-promo input[type=email]').val();

      $.post('/newsletter.php', 'email=' + email, function () {
        $('.newsletter-promo .form').addClass('is-hidden');
        $('.newsletter-promo .success').removeClass('is-hidden');
      });
    })
  ;

  $('header.top .search .navbar-link').click(function (e) {
    e.preventDefault();

    $('header.top form.search-form').toggleClass('is-visible').find('input[type="search"]').focus();

    return false;
  });
})(jQuery);

(function ($) {
  var scrollSpeed = 150;
  var px = 100;

  $(window).scroll(function () {
    $('body').toggleClass('is-scrolled-down', $(this).scrollTop() > px);
  });

  $('body').append('<span id="topButton"></span>');

  $('#topButton').click(function () {
    $('html, body').removeClass('is-scrolled-down').animate({ scrollTop: 0 }, scrollSpeed);
  });
})(jQuery);

(function ($) {
  var scrollSpeed = 150;

  var $toc = $('.widget.toc');
  var $headers = $('.content-container article :header');

  if ($toc.length === 0 || $headers.length === 0) return;

  var links = '<li><a class="toc"><i class="fas fa-list-ul"></i> Table of Contents</a></li>';

  $headers.each(function (i) {
    var $this = $(this);
    var level = $this.get(0).nodeName;

    $this.attr('data-toc-index', i);

    links += '<li class="' + level + '" data-toc-goto="' + i + '">' +  $this.html() + '</span>';
  });

  $toc.html('<ul>' + links + '</ul>');

  $(document).on('click', '.widget.toc ul li[class^="H"]', undefined, function (e) {
    e.preventDefault();

    if ($(this).text() === 'References') {
      $('.show-references').click();
    }

    var index = $(this).attr('data-toc-goto');
    var $header = $('[data-toc-index="' + index + '"]');
    var top = $header.offset().top - $('header.top').height() - 20;

    $toc.removeClass('visible');

    $('html, body').animate({ scrollTop: top }, scrollSpeed);

    return false;
  });

  $(document).on('click', '.widget.toc ul li a.toc', undefined, function (e) {
    e.preventDefault();

    $('.tools > .group > a.toc').click();

    return false;
  });
})(jQuery);

(function ($) {
  if (typeof(window.Fancybox) !== 'function') return;

  Fancybox.bind('div[id^="attachment_"] > a', {
    groupAll: true,
    idle: false,
    contentClick: 'toggleCover',
    caption: function (fancybox, slide) {
      return slide.triggerEl.parentNode.querySelector('.wp-caption-text').innerHTML;
    },
    tpl: {
      main: `<div class="fancybox__container has-sidebar" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">
        <div class="fancybox__backdrop"></div>
        <div class="fancybox__cols">
          <div class="fancybox__col">
            <div class="fancybox__carousel"></div>
            <div class="fancybox__footer"></div>
          </div>
          <div class="fancybox__col fancybox__data_container">
            <div class="fancybox__data"></div>
          </div>
        </div>
      </div>`,
    },
    Image: {
    },
    Panzoom: {
    },
    Thumbs: {
      showOnStart: true,
      type: 'classic',
    },
    Toolbar: {
      items: {
        thumbfix: {
          tpl: '<button class="f-button" title="Toggle thumbnails"><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>',
          click: function () {
            $('.fancybox__thumbs').toggleClass('is-hidden');
          },
        },
        sidebar: {
          tpl: `<button class="f-button f-sidebar-button"><svg style="transform:scale(0.9)" viewBox="0 0 524 512"><path style="stroke-width: 15px" d="M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg></button>`,
          click: (toolbar) => {
            toolbar.instance.container.classList.toggle('has-sidebar');
          },
        },
        dummy: {
          tpl: '<span></span>',
          click: function () {},
        }
      },
      display: {
        left: ['prev', 'next', 'thumbfix'],
        middle: ['dummy'],
        right: [ 'zoomIn', 'zoomOut', 'download', 'fullscreen', 'sidebar', 'close' ],
      },
    },
    on: {
      'setIdle': function (fancybox) {
        fancybox.endIdle();
      },
      'Carousel.ready': (fancybox) => {
        if (fancybox.userSlides.length === 0) return;

        var tables = [];
        var figures = [];

        for (var i = 0; i < fancybox.userSlides.length; i++) {
          var caption = fancybox.userSlides[i].triggerEl.parentNode.querySelector('.wp-caption-text').innerHTML;

          var isFigure = caption.match(/\bFigure *[0-9]+\./);
          var $caption = $('<li>' + caption + '</li>');

          $caption.attr('slide-index', i);

          $caption.bind('click.caption', function (e) {
            e.preventDefault();
            e.stopPropagation();

            fancybox.jumpTo($(this).attr('slide-index'));

            if (window.innerWidth <= 578) {
              fancybox.container.classList.toggle('has-sidebar');
            }

            return false;
          });

          if (i === fancybox.getSlide().index) {
            $caption.addClass('current');
          }

          if (isFigure) {
            figures.push($caption);
          } else {
            tables.push($caption);
          }
        }

        if (tables.length > 0) {
          var $tables = $('<ul class="tables"></ul>').append(tables);

          $(fancybox.container.querySelector('.fancybox__data'))
            .append('<h1>List of Tables</h1>')
            .append($tables)
          ;
        }

        if (figures.length > 0) {
          var $figures = $('<ul class="figures"></ul>').append(figures);

          $(fancybox.container.querySelector('.fancybox__data'))
            .append('<h1>List of Figures</h1>')
            .append($figures)
          ;
        }
      },
      'Carousel.change': (fancybox) => {
        $('li.current').removeClass('current');
        $('li[slide-index="' + fancybox.getSlide().index + '"]').addClass('current');
      }
    },
  });
})(jQuery);

(function ($) {
  $(document).on('click', '.accordion .accordion-opener', undefined, function (e) {
    e.preventDefault();

    $(this).toggleClass('is-closed').parents('.accordion').find('.accordion-content').slideToggle(250);

    return false;
  });
})(jQuery);

(function ($) {
  $(document).on('click', 'a.button.filter', undefined, function (e) {
    e.preventDefault();

    $('.filter-container').toggleClass('is-hidden');
    $(this).toggleClass('has-background-link has-text-white');
    $(this).find('.icon').toggleClass('has-text-grey-dark');
    $(this).find('i').toggleClass('fa-filter fa-times');

    return false;
  });

  $('a.button.filter.has-filters').trigger('click');
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '.dropdown-trigger', function (e) {
    e.preventDefault();

    $('.dropdown.is-active').not($(this).parents()).removeClass('is-active');

    $(this).closest('.dropdown').toggleClass('is-active');

    return false;
  });

  $('body').bind('click.dropdown', function (e) {
    console.log(e.target);
    $(e.target).find('.dropdown.is-active').removeClass('is-active');
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '.dropdown-item', function (e) {
    e.preventDefault();

    $(this)
      .closest('.dropdown')
      .toggleClass('is-active')
      .data('value', $(this).data('value'))
      .find('.dropdown-trigger button span:not(.icon)').text($(this).text().replace(/ \([0-9]+\)/, ''))
    ;

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '.apply', function (e) {
    e.preventDefault();

    $('.dropdown.is-active').removeClass('is-active');

    var date_from_year = parseInt($('#dropdown-menu-from-year').closest('.dropdown').data('value'));
    var date_from_month = parseInt($('#dropdown-menu-from-month').closest('.dropdown').data('value'));

    var date_to_year = parseInt($('#dropdown-menu-to-year').closest('.dropdown').data('value'));
    var date_to_month = parseInt($('#dropdown-menu-to-month').closest('.dropdown').data('value'));

    var date_from = String(date_from_year) + ('0' + String(date_from_month)).substring(1);
    var date_to = String(date_to_year) + ('0' + String(date_to_month)).substring(1);

    if (date_from > date_to) {
      date_from_year_original = date_from_year;
      date_from_month_original = date_from_month;

      date_from_year = date_to_year;
      date_from_month = date_to_month;

      date_to_year = date_from_year_original;
      date_to_month = date_from_month_original;
    }

    var queryParams = new URL(document.location).searchParams;

    queryParams.set('date_filter', 1);
    queryParams.set('from_year', date_from_year);
    queryParams.set('from_month', date_from_month);

    queryParams.set('to_year', date_to_year);
    queryParams.set('to_month', date_to_month);

    document.location.search = queryParams.toString();

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '#dropdown-menu-topics .dropdown-item', function (e) {
    e.preventDefault();

    var queryParams = new URL(document.location).searchParams;
    var topic_id = parseInt($(this).data('value'));

    if (topic_id > 0) {
      queryParams.set('topic_id', topic_id);
    } else {
      queryParams.delete('topic_id');
    }

    document.location.search = queryParams.toString();

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '#dropdown-menu-categories .dropdown-item', function (e) {
    e.preventDefault();

    var queryParams = new URL(document.location).searchParams;
    var cat_id = parseInt($(this).data('value'));

    if (cat_id > 0) {
      queryParams.set('cat_id', cat_id);
    } else {
      queryParams.delete('cat_id');
    }

    document.location.search = queryParams.toString();

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '.remove-topic-filter', function (e) {
    e.preventDefault();

    var queryParams = new URL(document.location).searchParams;
    queryParams.delete('topic_id');

    document.location.search = queryParams.toString();

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '.remove-category-filter', function (e) {
    e.preventDefault();

    var queryParams = new URL(document.location).searchParams;
    queryParams.delete('cat_id');

    document.location.search = queryParams.toString();

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.dropdown', '.remove-date-filter', function (e) {
    e.preventDefault();

    var queryParams = new URL(document.location).searchParams;
    queryParams.delete('date_filter');
    queryParams.delete('from_year');
    queryParams.delete('from_month');

    queryParams.delete('to_year');
    queryParams.delete('to_month');

    document.location.search = queryParams.toString();

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.audio', 'a.play-audio', function (e) {
    e.preventDefault();

    if (window.currentTrack) {
      console.log(window.currentTrack);
      window.currentTrack.children().remove();
    }

    var $audio = $('<audio autoplay src="' + $(this).data('src') + '">').appendTo($('#media-player-container-' + $(this).data('media-id')));

    $audio.mediaelementplayer({
      iconSprite: '/wp-content/themes/idcm/dist/css/images/mejs-controls.svg',
      features: [ 'playpause' ],
      isVideo: false,
      defaultAudioWidth: 'auto',
      success: function (media, node) {
        window.currentTrack = $(media).closest('.media-player-container');

        var $controls = $(node.parentNode.parentNode).siblings('.mejs__controls');
        $controls.prepend('<span class="icon is-clickable close-player"><i class="fas fa-volume-up"></i></span> <span class="text-label">Listen to Abstract</span>');
      },
    });

    return false;
  });
})(jQuery);

(function ($) {
  $('body').on('click.audio', 'span.close-player', function (e) {
    e.preventDefault();

    $(this).closest('.media-player-container').children().remove();

    return false;
  });
})(jQuery);
